import React, { memo } from 'react';

const EmailBodyRendererComponent = ({ onPreviewEmail, data }) => {
  if (data.hasError) {
    return null;
  }

  return (
    <a onClick={onPreviewEmail} role="button" tabIndex={0}>
      View Details
    </a>
  );
};

export const EmailBodyRenderer = memo(EmailBodyRendererComponent);
